import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MapService } from '@app/shared/services/map.service';
import { LatLngExpression } from 'leaflet';
import * as L from 'leaflet';
import { StationsService } from '@app/shared/services/stations.service';
import { AlertService } from '@app/shared/services/alert.service';
declare var UIkit: any;

@Component({
  selector: 'app-position-station',
  templateUrl: './position-station.component.html',
  styleUrls: ['./position-station.component.scss']
})
export class PositionStationComponent {

  private map: L.Map = null;
  private marker: L.Marker = null;
  private _timeout: any = null;
  public position: LatLngExpression = [0, 0];

  @Input() latitude: number = 0;
  @Input() longitude: number = 0;
  @Input() station: any = {};
  @Output() changed = new EventEmitter();

  constructor(
    private mapService: MapService,
    private stationService: StationsService,
    private alertService: AlertService
  ) { }

  ngOnChanges(): void {
    if (this.latitude === undefined || this.longitude === undefined) {
      return;
    }
    if (this.map && this.map.remove) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }
    this.position = [this.latitude, this.longitude];
    this.mapService.initMap("reposition", [this.latitude, this.longitude], 12, false).then((map) => {
      this.map = map;
      this.map.on('click', (e) => this.setPositionEvent(e));
      this.addMarker(this.position);
      this.fixCenter();
    });

    this.mapService.map.scrollWheelZoom.enable();
  }

  fixCenter(): void {
    setTimeout(() => {
      let latLngs = [this.marker.getLatLng()];
      let markerBounds = L.latLngBounds(latLngs);

      this.map.invalidateSize();
      this.map.fitBounds(markerBounds);
      this.map.setZoom(12);
    });
  }

  addMarker(position): void {
    this.marker = L.marker(position).addTo(this.map);
  }

  removeMarker(): void {
    if (this.marker !== null) {
      this.map.removeLayer(this.marker);
    }
  }

  setPositionTimeout(): void {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.removeMarker();
      this.addMarker(this.position);
    }, 250);
  }

  setPositionEvent(event): void {
    this.removeMarker();
    this.position = [event.latlng.lat, event.latlng.lng];
    this.addMarker(event.latlng);
  }

  updatePosition(): void {
    this.station.latitude = this.position[0];
    this.station.longitude = this.position[1];
    this.stationService.updateStation(this.station).then((res) => {
      this.alertService.alert("Les modifications ont été effectuées.");
    });
    this.changed.emit();
    UIkit.modal('#position-station').hide();
  }

}
